import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/hooks/useTheme";

// Pages
import HomePage from "@/pages/HomePage";
import StorePage from "@/pages/StorePage";
import VotePage from "@/pages/VotePage";
import StaffPage from "@/pages/StaffPage";
import WikiPage from "@/pages/WikiPage";

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/store" element={<StorePage />} />
          <Route path="/vote" element={<VotePage />} />
          <Route path="/staff" element={<StaffPage />} />
          <Route path="/wiki" element={<WikiPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster 
        position="bottom-right"
        toastOptions={{
          classNames: {
            toast: 'bg-card border-border text-foreground',
            title: 'text-foreground',
            description: 'text-muted-foreground',
          },
        }}
      />
    </ThemeProvider>
  );
}

export default App;
